import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './ContentRowPrice.module.css';

const ContentRowPrice = (props) => {
  const { id, price, setIsEdited } = props;
  const [priceInput, setPriceInput] = useState(price);

  useEffect(() => {
    setPriceInput(props.price);

    return () => props.setIsEdited(false);
  }, [price, setIsEdited]);

  const handleBlur = () => {
    if (props.price === priceInput) {
      console.log('change price to set');
    } else {
      props.setIsEdited(true);
      props.onPaywallChange(priceInput);
    }
  };

  const classes = styles['contentrowprice-input'];
  return (
    <>
      <input
        id={`paywall_${price}_${id}`}
        type="number"
        min="0"
        step="0.01"
        onChange={(e) => {
          setPriceInput(parseFloat(e.target.value));
        }}
        value={priceInput}
        className={classes}
        onBlur={handleBlur}
      />
    </>
  );
};

ContentRowPrice.propTypes = {
  id: PropTypes.node.isRequired,
  price: PropTypes.node.isRequired,
  setIsEdited: PropTypes.node.isRequired,
  onPaywallChange: PropTypes.node.isRequired,
};

export default ContentRowPrice;
